<template>
  <div class="w-full font-proxima">
    <div class="overflow-x-auto shadow-sm ring-1 ring-black ring-opacity-5 rounded-sm bg-white">
      <table class="min-w-full divide-y divide-gray-300">
        <thead class="bg-red-50">
          <tr>
            <th v-for="header in HEADERS" :key="header" class="p-2 text-left align-middle text-sm font-bold border border-white text-blue-500 whitespace-nowrap">
              {{ header }}
            </th>
          </tr>
        </thead>
        <tbody class="divide-y divide-gray-200 bg-white">
          <tr v-for="(row, index) in rows" :key="row.roleId ?? index" :class="index % 2 === 0 ? undefined : 'bg-gray-100'">
            <td class="px-3 py-2 text-sm text-black whitespace-nowrap">{{ row.displayName }}</td>
            <td class="px-3 py-2 text-sm text-black whitespace-nowrap">{{ row.position }}</td>
            <td class="px-3 py-2 text-sm text-black whitespace-nowrap">{{ row.locationName }}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <p class="mt-1 text-xs text-gray-500">
      Showing {{ rows.length.toLocaleString() }} of {{ (output?.count ?? rows.length).toLocaleString() }} staff members
    </p>
  </div>
</template>
<script setup lang="ts">
interface StaffRow {
  roleId?: number;
  displayName?: string;
  position?: string;
  locationName?: string;
}

const props = defineProps<{ part: { output?: { count?: number; staff?: StaffRow[] } } }>();

const HEADERS = ['Name', 'Position', 'Location'];

const output = computed(() => props.part.output);
const rows = computed<StaffRow[]>(() => output.value?.staff ?? []);
</script>
